export default "__VITE_ASSET__BxSVgcMv__"